// src/utils/uncontrolled.ts
import camelcase from "camelcase";
function getUncontrolledKey(key) {
  return camelcase(`default_${key}`);
}
function makeUncontrolledKeyMap(keys) {
  return keys.reduce((acc, key) => ({ ...acc, [getUncontrolledKey(key)]: key }), {});
}

export {
  getUncontrolledKey,
  makeUncontrolledKeyMap
};
//# sourceMappingURL=chunk-SI4FST6P.mjs.map